import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery } from "gatsby"
import Image from "gatsby-image"

import { brandViolet, brandPink } from "../styles/colors"

const FooterWrapper = styled.div`
  background-color: ${brandViolet};
  height: 200px;
`

const PrivacyPolicy = styled.div`
  flex: 1;
  text-align: right;
`

const FooterContainer = styled.div`
  display: flex;
  margin: 40px 0 30px 0;
  max-width: 1024px;
  margin: auto;
  font-family: "Open Sans", sans-serif;
  letter-spacing: 0.5px;
  align-items: center;
  padding-top: 30px;
`

const LinksContainer = styled.div`
  display: flex;
  margin: 0 20px;
`

const StyledLink = styled(Link)`
  padding: 0 5px;
  color: white;
  text-decoration: none;
  padding: 0 15px;

  &:hover {
    transform: scale(1.1);
  }
`

const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(
        absolutePath: { regex: "/assets/kernelgonnapanic_white.png/" }
      ) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return (
    <FooterWrapper>
      <FooterContainer>
        <Link to="https://kernelgonnapanic.pl">
          <Image fixed={data.logo.childImageSharp.fixed} />
        </Link>
        <LinksContainer>
          {/* <StyledLink to="/blog">Blog</StyledLink> */}
          <StyledLink to="/konsultacje">Konsultacje</StyledLink>
          <StyledLink to="https://www.instagram.com/kernelgonnapanic/">
            Instagram
          </StyledLink>
        </LinksContainer>
        {/* <PrivacyPolicy>
          <StyledLink to="/polityka-prywatnosci">
            Polityka prywatności
          </StyledLink>
        </PrivacyPolicy> */}
      </FooterContainer>
    </FooterWrapper>
  )
}

export default Footer
